<template>
    <div class="page">
        <Headers></Headers>
        <div class="banner">
            <!-- 顶部标题 -->
            <div class="pdfPageTitle mg_t">
                <div class="pdfPageTitle-txt">
                    <span class="pdfPageTitle-txt__first">绿色供应链</span>
                    <span class="pdfPageTitle-txt__second">(权重{{PdftStore.fromData.spaceEmissionGreenSupply?.weight}}%)</span>
                </div>
                <div class="pdfPageTitle-icon">
                    <img src="@/assets/img/page10.png">
                </div>
            </div>

            <!-- 顶部数据 -->
            <div class="top_box">
                <div class="left">
                    <div class="title mg_b">核查结论</div>
                    <div class="tx">{{PdftStore.fromData.spaceEmissionGreenSupply?.verificationConclusion}}</div>
                </div>
            </div>

            <!-- 明细 -->
            <div class="min_box">
                <div class="title">碳中和运营指数得分明细</div>
                <List :type=6  :id="'listPdfReport6'"/>
            </div>

            <!-- 数据图表 -->
            <div class="banner_box">
                <div class="left_box">
                    <div class="top_box_banner">
                        <div class="title">绿色供应链得分：</div>
                        <div class="jindu" v-if="PdftStore.fromData.spaceEmissionGreenSupply">
                            <Progess :name="'page10progess'" :num="PdftStore.fromData.spaceEmissionGreenSupply?.updateScore" :maxNum="'xxx'" :minNum="'xxx'" :carbonNum="'xxx'" :max='100' :min='30'/>
                        </div>
                    </div>
                    
                    <div class="title">供应链减排措施与采用</div>
                    <div class="ec_t" v-if="PdftStore.fromData.spaceEmissionGreenSupply">
                        <EchartsList 
                        :xdata="PdftStore.fromData.spaceEmissionGreenSupply?.reportItemHistogram.xdata" 
                        :ydata="ydata" 
                        :imgId="PdftStore.fromData.orgInfo.logoId"
                        :series="PdftStore.fromData.spaceEmissionGreenSupply?.reportItemHistogram.series" 
                        :name="'page10echartslist'"
                        />
                    </div>
                </div>
                <div class="right_box">
                    <div class="top_box_banner">
                        <div class="title">评分逻辑</div>
                        <div class="txt">{{PdftStore.fromData.spaceEmissionGreenSupply?.scoreStandard}}</div>
                    </div>
                    <div class="title">碳中和运营指数综合表现</div>
                    <div class="ec_t" v-if="PdftStore.fromData.spaceEmissionGreenSupply">
                        <Echarts :name="'page10echarts'" :type="'f'"/>
                    </div>
                </div>
            </div>
            <!-- 底部 -->
            <Bottoms/>
            <div class="flxed">08</div>
        </div>
    </div>
</template>

<script>
import { reactive, toRefs, onBeforeMount, onMounted } from 'vue'
import { useRoute, useRouter } from 'vue-router';
import Headers from '../components/headers.vue'
import Bottoms from '../components/bottoms.vue'
import List from '../components/list.vue'
import Progess from '../components/progess.vue'
import EchartsList from '../components/echartsList.vue'
import Echarts from '../components/echarts.vue'
import { usePdftStore } from '@/store/pdf'
import { formatDateTimeYYmm, formatDateTimeYY } from '@/utils/date'
export default {
    name: 'page10',
    components:{Headers, Bottoms, List, Progess, EchartsList, Echarts},
    setup() {
        const data = reactive({
            xdata:{
                name:'绿色减\n排措施',
                data:['A','B','C','D','E','F']
            },
            ydata:{
                name:'企业数量',
                type:0
            },
            series:{
                data:[
                    {
                        value:12,
                        type: 'bar',
                        name:'A'
                    }, 
                    {
                        value:6,
                        type: 'bar',
                        name:'B'
                    },  
                    {
                        value:9,
                        type: 'bar',
                        name:'C'
                    },  
                    {
                        value:16,
                        type: 'bar',
                        name:'D'
                    }, 
                    {
                        value:5,
                        type: 'bar',
                        name:'E'
                    },  
                    {
                        value:7,
                        type: 'bar',
                        name:'F'
                    },  
                ],
                title:"隆基股份采用的供应链减排措施",
            },
        })
        //引入数据管理库
        const PdftStore = usePdftStore()
        const formatDateTimeYYmms = (str) => {
            return formatDateTimeYYmm(str)
        }
        const formatDateTimeYYs = (str) => {
            return formatDateTimeYY(str)
        }
        onBeforeMount(() => {})
        onMounted(() => {})
        return {
            PdftStore,
            formatDateTimeYYmms,
            formatDateTimeYYs,
            ...toRefs(data),
        }
    },
}

</script>
<style scoped lang='less'>
.mag_t{
    margin-top: 20px;
}
.margin_t{
    margin-top: 10px;
}
.page{
    width: 1512px;
    height: 2149px;
    margin: 0 auto;
    background: #FFFFFF;
    position: relative;
    .banner{
        width: 100%;
        padding: 0 130px;
        .mg_t{
            margin-top: 96px;
        }
        .flxed{
            position: absolute;
            right: 20px;
            bottom: 20px;
            font-size: 24px;
            font-weight: 400;
            color: #333333;
            line-height: 33px;
        }
        .top_box{
            margin-top: 50px;
            display: flex;
            .title{
                font-size: 28px;
                font-weight: 500;
                color: #333333;
                line-height: 42px;
            }
            .left{
                width: 100%;
                .mg_b{
                    margin-bottom: 20px;
                }
                .txt{
                    font-size: 32px;
                    font-weight: 500;
                    line-height: 36px;
                    color: #333333;
                    white-space: normal;
                    word-wrap: break-word;
                }
                .tx{
                    margin-top: 15px;
                    font-size: 16px;
                    text-align: justify;
                    line-height: 24px;
                    font-weight: 400;
                    color: #666666;
                    white-space: normal;
                    word-wrap: break-word;
                }
            }
            .right{
                width: calc(100% - 710px);
                padding-left: 40px;
                border-left: 1px solid #C5C5C6;
                .txt{
                    font-size: 16px;
                    font-weight: 400;
                    text-align: justify;
                    color: #333333;
                    line-height: 24px;
                    margin-top: 23px;
                    white-space: normal;
                    word-wrap: break-word;
                }
            }
            
        }
        .min_box{
            margin-top: 55px;
            font-size: 24px;
            font-weight: 500;
            color: #333333;
            line-height: 42px;
            .title{
                margin-bottom: 33px;
            }
        }
    }
}
.banner_box{
    display: flex;
    width: 100%;
    margin-top: 70px;
    .left_box{
        width: 670px;
        height: 100%;
        padding-right: 40px;
        border-right: 1px solid #C5C5C6;
    }
    .right_box{
        width: calc(100% - 670px);
        height: 100%;
        padding-left: 39px;
    }
    .top_box_banner{
        height: 350px;
    }
    .title{
        font-size: 28px;
        font-weight: 500;
        color: #333333;
        line-height: 42px;
    }
    .jindu{
        height: calc(350px - 42px);
        width: 100%;
        display: flex;
        align-items: center;
    }
    .mg_top{
        margin-top: 90px;
    }
    .ec_t{
        margin-top: 10px;
        width: 100%;
        height: 413px;
    }
    .txt{
        font-size: 16px;
        font-weight: 400;
        text-align: justify;
        color: #333333;
        line-height: 24px;
        margin-top: 10px;
        white-space: normal;
        word-wrap: break-word;
    }
    .txt_s{
        color: #999999;
    }
}
</style>